import { projects } from "./projects"
export const mock = { projects }
